module.exports = __webpack_public_path__ + "static/media/icon-service-modulesB1.2d907dd6.png";